<template>
  <v-container fluid>
    <v-row v-if="profile == 5">
      <v-col>
        <v-data-table
          locale="fr"
          :headers="headers"
          @click:row="seeRecourse"
          no-data-text="Aucun recours disponible"
          :items="this.$store.getters['Auth/getAllRecourse'].data"
          :search="search"
          sort-by="title"
          class="elevation-1 mb-5 px-5"
        >
          <template v-slot:[`item.status`]="{}">
            <v-icon medium color="red darken-2">mdi-lock</v-icon>
          </template>
          <template v-slot:[`item.openSession`]="{ item }">{{
            item.openSession ? item.openSession : "--" | moment("dddd, Do MMMM YYYY à HH:mm:ss A")
          }}</template>
          <template v-slot:[`item.createdAt`]="{ item }">{{
            item.createdAt ? item.createdAt : "--" | moment("dddd, Do MMMM YYYY à HH:mm:ss A")
          }}</template>
          <template v-slot:top>
            <v-toolbar flat color="white" class="mb-5">
              <v-toolbar-title>Liste des recours</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Recherchez un recours"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    search: "",
    initial: false,
    headers: [
      {
        text: "Objet",
        align: "start",
        sortable: true,
        value: "object"
      },
      {
        text: "Type",
        align: "start",
        sortable: true,
        value: "recourseType.description"
      },
      {
        text: "Document en rapport",
        sortable: true,
        value: "document.object"
      },
      {
        text: "Email du concernée",
        sortable: true,
        value: "createdBy.email"
      },
      {
        text: "Date",
        sortable: true,
        value: "createdAt"
      }
    ],
    recourse: {
      object: "",
      doc_id: 0,
      recourse_type: 0,
      file: []
    }
  }),
  created() {
    let Virt = [];

    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
    this.user_data = Virt;
    this.$store.dispatch("Auth/loadAllRecourse");
    this.$store.dispatch("Auth/loadAllDocValidated");
  },
  methods: {
    addRecourse() {
      let data = new FormData();
      data.append("object", this.recourse.object);
      data.append("document_id", this.recourse.doc_id);
      data.append("recourse_type", this.recourse.recourse_type);
      data.append("file", this.recourse.file[0]);

      this.$store.dispatch("Auth/addRecourse", data);

      this.recourse.object = "";
      this.recourse.doc_id = 0;
      this.recourse.recourse_type = 0;
      this.recourse.file = [];
    },
    seeRecourse(item) {
      const { id } = item;
      this.$router.push({ name: "RegshowRecours", params: { id: parseInt(id) } });
    }
  }
};
</script>
